import { throttle } from "lodash";
import { galleryPopup } from "./gallery-popup";
import { initMouseWheelScroll } from "./mouse-wheel-scroll";
import { initMenu} from "./menu";

declare const jQuery: any;
const $ = jQuery;

function fixMainSliderHeight(): void
{
    const $window = $(window);
    $(`.momentum-scroller`).each(function (this: HTMLElement) {
        const $wrap = $(this);
        const $slider = $wrap.children(`.slider`);
        const $sliderItems = $slider.find(`.slider-items-slider`).first().children(`.slider-item`);
        const $elsToResize = $wrap.add($slider).add($sliderItems).add($wrap.find(`.momentum-splash-screen,.momentum-splash-screen,.momentum-gallery-tiles,.momentum-gallery-popup`));
        const fix = () => {
            $elsToResize.css({ height: window.innerHeight });
        };
        fix();
        const throttledFix = throttle(fix, 60, { leading: true });
        let scrolledRecently = false;
        let scrolledRecentlyTimer: any;
        const setScrolledRecentlyFalseTimed = () => {
            clearTimeout(scrolledRecentlyTimer);
            scrolledRecentlyTimer = setTimeout(() => {
                scrolledRecently = false;
            }, 300);
        };
        $window.on("orientationchange load", throttledFix).on("resize", function () {
            if (!scrolledRecently)
            {
                throttledFix();
            }
        }).on("scroll", throttle(() => {
            scrolledRecently = true;
            setScrolledRecentlyFalseTimed();
        }, 40, { trailing: true }));
    });

    // popups - FIXME not working on small devices
    const $popups = $(`.popup`);
    const fixPopupHandler = function fixPopupHandler(this: HTMLElement) {
        const h = window.innerHeight;
        const $popup = $(this);
        
        $popup.add($popup.find(`.momentum-gallery-popup`)).css({ height: h, minHeight: h });
    };
    $popups.on("opened", fixPopupHandler);
    $window.on("orientationchange resize", throttle(() => {
        $popups.filter(`.show`).each(fixPopupHandler);
    }, 50, { trailing: true }));
}

// Prevents little vertical sliver of previous image in gallery popup slider:
function fixGallerySlidersImageSidelineBug(): void
{
    $(`.momentum-gallery-popup .slider`).each(function (this: HTMLElement) {
        const $slider = $(this);
        const $items = $slider.find(`.slider-item`);
        $slider.on("change", function (event: Event, data: any) {
            $items.addClass("hide").eq(data.itemIndex).removeClass("hide");
        });
    });
}

function resetGalleryTilesScrollLeft(): void
{
    $(".momentum-gallery-tiles .scrolly").scrollLeft(0);
}

fixMainSliderHeight();
initMouseWheelScroll();
galleryPopup();
fixGallerySlidersImageSidelineBug();
resetGalleryTilesScrollLeft();
initMenu();
